<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="countries"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark autocomplete>
  </v-select>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: mapGetters({
      countries: 'application/countries'
    }),
    methods: mapActions({
      fetchCountries: 'application/fetchCountries'
    }),
    beforeMount () {
      this.fetchCountries()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Country.vue